/*
 * @Author:
 * @LastEditTime: 2022-07-08 18:15:52
 * @Description:
 */
import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class MdPowerGrid {
  // 查询站点列表
  static async addManageList(payload) {
    const [err, res] = await To(
      axios.get(`${wizStandardInstance}/api/Billboard/query_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 删除列表项
  static async deleteList(payload) {
    const [err, res] = await To(
      axios.delete(`${wizStandardInstance}/api/Billboard/billboard`, {
        data: {
          ids: payload,
        },
      })
    )
    return Callback(err, res)
  }
  // 新增列表项
  static async addList(payload) {
    const [err, res] = await To(
      axios.post(`${wizStandardInstance}/api/Billboard/billboard`, payload)
    )
    return Callback(err, res)
  }
  // 编辑站点
  static async editList(payload) {
    const [err, res] = await To(
      axios.put(`${wizStandardInstance}/api/Billboard/billboard`, payload)
    )
    return Callback(err, res)
  }
}
